module.exports = __webpack_public_path__ + "static/media/icons-lelt-open-arrow.10b6c9cb.svg";